import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

const Breadcrumb = (props) => (
  <Link
    sx={{ paddingLeft: "6px" }}
    {...props}
    component={RouterLink}
    underline="hover"
  />
);

export default Breadcrumb;
